import { render, staticRenderFns } from "./DesignDescription.vue?vue&type=template&id=206f5f26"
import script from "./DesignDescription.vue?vue&type=script&lang=js"
export * from "./DesignDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports